const fr = {
  welcome: {
    close: 'Fermer',
    tagline1: 'Faites vos choix.',
    tagline2: 'Grimpez au classement.',
    tagline3: 'Gagnez des prix.',
    howToPlay: 'Comment jouer',
    letsPlay: 'Jouer',
    altLogo: "Pick'em",
    altBrand: 'Circus Daily',
  },
  howToPlay: {
    back: 'Retour',
    title: 'Comment jouer',
    demoQuestion: 'Qui va gagner le match ?',
    demoTeamUsa: 'USA',
    demoTeamBelgium: 'Belgique',
    step1Title: "Pick'Em",
    step1Description: 'Verrouillez vos prédictions avant le coup d’envoi',
    step2Title: 'Marquez gros',
    step2Description: 'Chaque bon choix vous rapporte des points',
    step3Title: 'Battez la concurrence',
    step3Description: 'Dépassez amis et partisans au classement',
    step4Title: 'À vous la gloire',
    step4Description: 'Gagnez des prix et montrez qui est le meilleur',
    cta: "C'est compris, jouons",
  },
  game: {
    status: {
      loading: 'Chargement...',
      locked: 'Verrouillé',
      live: 'EN DIRECT',
      complete: 'Terminé',
      correct: 'correct',
    },
    actions: {
      edit: 'Modifier',
      editPicks: 'Modifier les choix',
      viewPicks: 'Voir les choix',
      playNow: 'Jouer maintenant',
      leaderboard: 'Classement',
      viewLeaderboard: 'Classement',
      viewResults: 'Voir les résultats',
    },
    results: {
      rank: 'Rang',
      totalPts: 'Total Pts',
    },
    labels: {
      start: 'Début :',
      picks: 'Choix :',
      firstPrize: '1er prix :',
      vs: 'vs',
      yes: 'Oui',
      no: 'Non',
      free: 'GRATUIT',
      prizePool: 'Cagnotte :',
      prizePoolFallback: 'Cagnotte',
      numPicks: 'nº choix :',
      points: 'Points :',
      rank: 'Rang :',
      myPrize: 'Mon prix :',
    },
    time: {
      day: 'Jour',
      days: 'Jours',
      hour: 'Heure',
      hours: 'Heures',
      soon: 'Bientôt',
      startingSoon: 'Commence bientôt...',
    },
    contestClosed: 'Ce match a commencé et ce concours est fermé.',
    fallbackTitle: 'Compétition',
    fallbackTeam: 'Équipe {{n}}',
    fallbackPlayer: 'Joueur {{n}}',
    fallbackOption: 'Option {{n}}',
    unknownPlayer: 'Joueur inconnu',
    ordinals: {
      st: 'er',
      nd: 'e',
      rd: 'e',
      th: 'e',
    },
  },
  navigation: {
    filter: 'Filtrer',
    edit: 'Modifier',
    chat: 'Discussion',
    code: 'Code',
    mainNav: 'Navigation principale',
    backToLobby: 'Retour au lobby',
    leaderboard: 'Classement',
  },
  actions: {
    clear: 'Effacer',
    quickPick: 'Choix rapide',
    favouritePick: 'Choix préféré',
    submitPicks: 'Continuer pour confirmer',
    submitMyPicks: 'Soumettre mes choix',
    editMyPicks: 'Modifier mes choix',
    submitting: 'Soumission...',
    confirmationTitle: 'Confirmation',
    termsAgreement: "J'ai lu et accepté les CGU Circus Daily",
    entryConfirmationMessage:
      'Veuillez confirmer votre participation à ce concours. Vous pouvez modifier vos choix jusqu’au début du premier match.',
    updateSelections: 'Mettre à jour les sélections',
    saveChanges: 'Enregistrer',
    cancel: 'Annuler',
    retry: 'Réessayer',
    goBack: 'Retour',
    tryAgain: 'Réessayer',
    reloadPage: 'Recharger la page',
    close: 'Fermer',
    back: 'Retour',
  },
  tabs: {
    lobby: 'Accueil',
    myPicks: 'Mes choix',
    play: 'Jouer',
    recent: 'Récent',
    leaderboard: 'Classement',
  },
  filter: {
    all: 'Tous',
  },
  leaderboard: {
    today: "Aujourd'hui",
    week: 'Semaine',
    season: 'Saison',
    daily: 'Quotidien',
    monthly: 'Mensuel',
    month: 'Mois',
    rank: 'Rang',
    user: 'Utilisateur',
    player: 'Joueur',
    points: 'Points',
    prize: 'Prix',
    pickem: 'Pickem',
    pickemLeaderboard: 'Classement Pickem',
    close: 'Fermer',
    scrollForMore: 'Faites défiler pour plus',
    loadMore: 'Charger plus',
    scrollToTop: 'Retour en haut',
    failedToLoad: 'Échec du chargement du classement. Veuillez réessayer.',
    noData: 'Aucune donnée de classement disponible pour cette période.',
    absoluteWinner: 'Gagnant absolu - première entrée correcte soumise',
    loading: 'Chargement du classement...',
    loadingShort: 'Chargement...',
    weekLabel: 'Semaine {{n}}',
    globalTitle: 'Classement mondial',
    noActive: 'Aucun classement actif',
    picksLoading: 'Chargement des choix...',
    noPicks: 'Aucun choix disponible',
    prizeDetails: 'Détails des prix',
    crowns: 'Couronnes',
    noSelection: 'Aucune sélection',
    viewLeague: 'Classement >',
    pickems: {
      loading: 'Chargement des pickems...',
      failed: 'Échec du chargement des pickems.',
      empty: 'Aucun pickem trouvé.',
    },
    weekly: {
      loading: 'Chargement des données hebdomadaires...',
      failed: 'Échec du chargement des données hebdomadaires.',
      empty: 'Aucune donnée hebdomadaire disponible.',
    },
  },
  league: {
    settings: {
      title: 'PARAMÈTRES',
      showLeaderboards: 'Afficher les classements',
      users: 'Utilisateurs',
      usersCount: '{{count}} utilisateurs',
      remove: 'Retirer',
      deleteGroup: 'Supprimer le groupe',
      deleteConfirm: 'Supprimer cette ligue ?',
      deleteConfirmNamed: 'SUPPRIMER « {{name}} » ?',
      deleteMessage: 'Tous les amis seront retirés du classement.',
      removePlayerConfirm: 'Retirer ce joueur ?',
      removePlayerConfirmNamed: 'RETIRER « {{name}} » ?',
      delete: 'Supprimer',
      cancel: 'Annuler',
      removePlayer: 'Retirer le joueur',
    },
  },
  pages: {
    gamesCount: 'Sélectionnez un concours',
    recentResults: 'Résultats récents ({{count}})',
    noGamesAvailable: 'Aucune compétition active',
    noGamesAvailableSubtitle:
      "Il n'y a aucune compétition en cours pour le moment. Revenez bientôt pour de nouveaux concours.",
    noCompletedGames: "Il n'y a pas encore de jeux PICK'EM terminés.",
    noRecentResults: 'Aucun résultat récent',
    noRecentResultsSubtitle:
      'Les concours terminés des 7 derniers jours apparaîtront ici. Consultez le lobby pour jouer.',
    noPicksSubmitted: 'Aucune sélection soumise',
    noPicksSubmittedSubtitle:
      "Vous n'avez actuellement aucune sélection. Consultez les derniers concours dans le lobby pour jouer.",
    viewAvailableContests: 'Voir les concours disponibles',
  },
  common: {
    picks: 'choix',
    loading: 'Chargement...',
    cancel: 'Annuler',
    retry: 'Réessayer',
    goBack: 'Retour',
    back: 'Retour',
    close: 'Fermer',
    error: 'Erreur',
  },
  a11y: {
    contestViews: 'Vues du concours',
    moreOptions: "Plus d'options",
    contestDetails: 'Détails du concours',
    breadcrumb: 'Fil d’Ariane',
    scrollToTop: 'Retour en haut',
    contestLogo: 'Logo du concours',
    goBack: 'Retour',
    leagueIcon: 'Icône de ligue',
    progress: 'Progression : {{completed}} sur {{total}}',
  },
  footer: {
    termsAndConditions: 'Termes et conditions',
  },
  tiebreaker: {
    title: "Bris d'égalité",
    defaultDescription: 'Prédisez le score total',
  },
  toast: {
    selectionsCleared: 'Vos sélections ont été effacées !',
    quickPicks: {
      title: 'Choix rapides sélectionnés !',
      description: 'Des sélections aléatoires ont été faites pour toutes les questions.',
    },
    popularPicks: {
      title: 'Choix populaires sélectionnés !',
      description: 'Des sélections populaires ont été faites pour toutes les questions.',
    },
    contestClosed: {
      title: 'Concours fermé',
    },
    noSelections: {
      title: 'Aucune sélection',
      description: 'Veuillez faire au moins une sélection avant d’enregistrer.',
    },
    consentSaveFailed: {
      title: 'Impossible d’enregistrer le consentement',
      description: 'Veuillez réessayer.',
    },
    submitSuccess: {
      title: 'Choix enregistrés',
      description: 'Vos sélections ont été soumises avec succès.',
    },
    submitError: {
      title: 'Impossible d’enregistrer les choix',
      description: 'Une erreur s’est produite. Veuillez réessayer.',
    },
  },
  modal: {
    picksSubmitted: {
      title: 'Sélections soumises',
      message: 'Vos sélections ont été enregistrées.',
      editMessage: "Modifiez-les à tout moment avant le coup d'envoi.",
      returnToLobby: 'Voir mes choix',
      likeYourPicks: 'Vous aimez vos choix ?',
      buildBetSlip: 'Créez un billet à partir de vos sélections.',
      youCouldWin: 'VOUS POURRIEZ GAGNER',
      fromBet: 'avec un pari de {{amount}} $',
      addToBetSlip: 'Ajouter au billet',
    },
    quickPick: {
      title: 'Entrée choix rapide',
      description:
        'Nous remplirons votre entrée avec des sélections aléatoires. Modifiez-les avant le verrouillage.',
      confirm: 'Choix aléatoires',
    },
    favouritePick: {
      title: 'Choix favoris',
      description:
        'Construisez rapidement votre entrée avec les choix les plus sélectionnés par les autres joueurs.',
      confirm: 'Sélectionner les favoris',
    },
    clearPicks: {
      title: 'Retirer tous les choix',
      description:
        'Supprimez vos sélections actuelles et recommencez. Vous pourrez choisir de nouveaux choix avant de soumettre.',
      confirm: 'Effacer les choix',
    },
    clearSelections: {
      title: 'EFFACER LES SÉLECTIONS',
      confirm: 'Effacer',
      cancel: 'Annuler',
    },
    leagueCreated: {
      title: 'LIGUE CRÉÉE !',
      pinMessage: 'Partagez ce NIP avec vos amis pour rejoindre votre ligue.',
      copy: 'Copier',
      share: 'Partager',
      viewLeague: 'Voir la ligue',
      shareTitle: 'Rejoins ma ligue !',
      shareText: 'Utilise le NIP {{pin}} pour rejoindre ma ligue.',
    },
    contestDetails: {
      title: 'Détails du concours',
      rulesError: 'Impossible de charger les règles. Veuillez réessayer.',
      howToPlay: 'Comment jouer',
      dailyPrizes: 'Prix quotidiens',
      monthlyPrizes: 'Prix mensuels',
      payout: {
        title: 'Répartition des prix',
        rank: 'Rang',
        cash: 'Argent',
        crowns: 'Couronnes',
      },
      fallback: {
        howToPlay1: 'Faites vos choix avant le début du concours.',
        howToPlay2: 'Gagnez des points pour chaque bonne sélection.',
        howToPlay3: 'Grimpez au classement et gagnez des prix.',
        daily1: 'Les prix quotidiens sont attribués selon votre rang.',
        monthly1: 'Les prix mensuels sont attribués à la fin du mois.',
      },
    },
  },
  competition: {
    error: {
      notFound: 'Compétition introuvable',
    },
    ipBlocked: {
      title: 'Accès restreint',
      message:
        'Ce concours est uniquement disponible sur le Wi-Fi Delta. Veuillez vous y connecter pour continuer.',
    },
  },
  errors: {
    toastTitle: 'Erreur',
    network: 'Erreur réseau. Veuillez vérifier votre connexion.',
    loginRequired: 'Veuillez vous connecter pour continuer.',
    forbidden: "Vous n'avez pas l'autorisation d'accéder à cette ressource.",
    invalidRequest: 'Requête invalide. Veuillez vérifier vos informations.',
    server: 'Erreur serveur. Veuillez réessayer plus tard.',
    unexpected: 'Une erreur inattendue s’est produite.',
    occurred: 'Une erreur s’est produite.',
    unableToConnect: 'Impossible de se connecter. Vérifiez votre connexion Internet et réessayez.',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    noPermission: "Vous n'avez pas l'autorisation d'effectuer cette action.",
    checkInput: 'Veuillez vérifier vos informations et réessayer.',
    serversIssues:
      'Nos serveurs rencontrent des problèmes. Veuillez réessayer dans quelques instants.',
    generic: 'Une erreur s’est produite. Veuillez réessayer.',
  },
  errorBoundary: {
    title: 'Une erreur s’est produite',
    description: 'Une erreur inattendue s’est produite. Veuillez réessayer.',
    tryAgain: 'Réessayer',
    reloadPage: 'Recharger la page',
  },
  app: {
    configError: {
      title: 'Erreur de configuration',
      description: 'Échec du chargement de la configuration. Veuillez réessayer.',
    },
    authFailed: {
      title: 'Échec de l’authentification',
      clerkMissing: "L'authentification n'est pas configurée. Veuillez contacter le support.",
    },
  },
  auth: {
    callback: {
      completing: 'Finalisation de la connexion…',
      pleaseWait: 'Veuillez patienter…',
      failed: 'Échec de l’authentification',
      missingToken: "Jeton d'authentification manquant.",
      returnHome: "Retour à l'accueil",
    },
    clerk: {
      signIn: 'Se connecter',
      createAccount: 'Créer un compte',
      alreadyHaveAccount: 'Vous avez déjà un compte ?',
    },
  },
  marketingConsent: {
    headline: '85 000 $ EN PRIX TOTAUX',
    subheadline: 'Brassé pour des victoires légendaires',
    checkboxPrompt:
      'Cochez la case ci-dessous pour recevoir des offres exclusives, des nouvelles et des mises à jour de Modelo.',
    eligibilityText:
      "Les participants doivent avoir 21 ans ou plus et être résidents des États-Unis/DC. En cliquant sur « JOUER GRATUITEMENT », j'affirme que j'ai 21 ans ou plus, que je suis résident des États-Unis/DC et que j'ai lu et accepté le règlement officiel.",
    footerText:
      "*Pour plus de détails sur la collecte et l'utilisation de vos informations par DraftKings, consultez notre Politique de confidentialité. Vous pouvez refuser le partage de vos informations avec Modelo en écrivant à privacy@cbrands.com.",
    buttonText: 'JOUER GRATUITEMENT',
    brandFallback: 'Draft Kings',
    consentBodyBeforeLinks:
      "J'autorise DraftKings à partager mon adresse courriel avec Modelo et consens à l'utilisation de mes renseignements personnels à des fins de marketing, d'analyse et de publicité ciblée, y compris la conversion de mon adresse courriel en identifiants, par Modelo et d'autres marques CBI. Sous réserve de l'",
    consentBodyBetweenLinks: 'et des',
    consentBodyAfterLinks: ' de Modelo.',
    footerBeforePrivacy:
      '*Pour plus de détails sur la collecte et l’utilisation de vos informations par DraftKings, consultez notre',
    footerAfterPrivacy:
      '. Vous pouvez refuser le partage de vos informations avec Modelo en écrivant à',
    privacyPolicy: 'Politique de confidentialité',
    privacyNotice: 'avis de confidentialité',
    userAgreement: "conditions d'utilisation du site",
    a11y: {
      close: 'Fermer le consentement marketing',
      consentCheckbox: 'Consentir au partage d’informations avec Modelo',
    },
  },
  prize: {
    crownsSuffix: 'c',
  },
  date: {
    tbd: 'Date à confirmer',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
    days: '{{count}} jours',
    daysAgo: 'Il y a {{count}} jours',
    oneDayHyphen: '1-jour',
    daysHyphen: '{{count}}-jours',
  },
  friends: {
    challengeTitle: 'DÉFIEZ VOS AMIS',
    challengeSubtitle: 'Créez un classement privé pour vous et vos amis !',
    joinLeague: 'Rejoindre une ligue',
    createLeague: 'Créer une ligue',
    inviteHint: 'Vous avez reçu une invitation ? Rejoignez en utilisant votre NIP',
  },
  stats: {
    rushing_yards: 'Verges au sol',
    passing_yards: 'Verges à la passe',
    receptions: 'Réceptions',
    receiving_yards: 'Verges à la réception',
    touchdowns: 'Touchdowns',
    passing_touchdowns: 'TDs à la passe',
    rushing_touchdowns: 'TDs au sol',
    interceptions: 'Interceptions',
    fumbles: 'Balonnesés',
    sacks: 'Sacks',
    tackles: 'Plaquages',
    points: 'Points',
    assists: 'Passes décisives',
    rebounds: 'Rebonds',
    steals: 'Interceptions',
    blocks: 'Contres',
    blocked_att: 'Tentatives bloquées',
    blocked_shots: 'Tirs bloqués',
    turnovers: 'Pertes de balle',
    three_points_made: 'Paniers à 3 pts',
    three_points_att: 'Tentatives à 3 pts',
    three_points_pct: '% à 3 pts',
    two_points_made: 'Paniers à 2 pts',
    two_points_att: 'Tentatives à 2 pts',
    two_points_pct: '% à 2 pts',
    free_throws_made: 'Lancer-francs réussis',
    free_throws_att: 'Tentatives aux lancer-francs',
    free_throws_pct: '% aux lancer-francs',
    field_goals_made: 'Tirs réussis',
    field_goals_att: 'Tentatives de tirs',
    field_goals_pct: '% aux tirs',
    minutes: 'Minutes',
    offensive_rebounds: 'Rebonds offensifs',
    defensive_rebounds: 'Rebonds défensifs',
    personal_fouls: 'Fautes personnelles',
    plus_minus: 'Plus/Moins',
    double_doubles: 'Double-doubles',
    triple_doubles: 'Triple-doubles',
    goals: 'Buts',
    runs: 'Points',
    hits: 'Coups sûrs',
    home_runs: 'Coups de circuit',
    rbi: 'Points produits',
    strikeouts: 'Retraits sur prises',
    soccer_goals: 'Buts',
    soccer_assists: 'Passes décisives',
    soccer_shots: 'Tirs',
    soccer_shots_on_target: 'Tirs cadrés',
    soccer_passes: 'Passes',
    soccer_pass_accuracy: 'Précision des passes',
    soccer_tackles: 'Tacles',
    soccer_clearances: 'Dégagements',
    soccer_yellow_card: 'Cartons jaunes',
    soccer_red_card: 'Cartons rouges',
    soccer_minutes_played: 'Minutes jouées',
    soccer_saves: 'Arrêts',
    soccer_corners: 'Corners',
    soccer_fouls: 'Fautes',
    soccer_possession: 'Possession',
    soccer_team_goals: 'Buts de l’équipe',
    soccer_team_shots: 'Tirs de l’équipe',
    soccer_team_shots_on_target: 'Tirs cadrés de l’équipe',
    soccer_team_yellow_cards: 'Cartons jaunes de l’équipe',
    soccer_team_red_cards: 'Cartons rouges de l’équipe',
  },
  question: {
    over: 'Plus',
    under: 'Moins',
    selectPlayer: 'Sélectionner un joueur',
    selectTeam: 'Sélectionner une équipe',
    pick1Player: 'Choisir 1 joueur',
    pick1Team: 'Choisir 1 équipe',
    unknown: 'Inconnu',
  },
} as const;

export default fr;
